"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactToastify = require("react-toastify");
var _TwoFactor = require("./TwoFactor");
var _state = require("../../../state");
var _ui = require("../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Page = function Page(_ref) {
  var loginPath = _ref.loginPath;
  var _useOAuth = (0, _state.useOAuth)(),
    google = _useOAuth.google;
  var twoFactorState = (0, _state.useTwoFactor)();
  var params = new URLSearchParams((0, _reactRouterDom.useLocation)().search);
  var authCode = params.get('code');
  if (authCode) {
    if (twoFactorState.kind) return /*#__PURE__*/_react.default.createElement(_TwoFactor.TwoFactor, {
      authCode: authCode,
      loginPath: loginPath
    });
    if (google.loginDone) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: loginPath
    });
    if (!google.loginLoading) {
      google.login({
        code: authCode
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  var error = params.get('error');
  if (error === 'email') {
    (0, _reactToastify.toast)( /*#__PURE__*/_react.default.createElement(_ui.Notification, {
      content: "Email was not provided",
      type: "danger",
      title: "Error"
    }), {
      toastId: 'oauth:email'
    });
  } else if (error === 'not_unique') {
    (0, _reactToastify.toast)( /*#__PURE__*/_react.default.createElement(_ui.Notification, {
      content: "Such user already exists",
      type: "danger",
      title: "Error"
    }), {
      toastId: 'oauth:not_unique'
    });
  }
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: loginPath
  });
};
exports.Page = Page;